export const loadMarker = (
  marker,
  marker1,
  map,
  shippingLatitude,
  shippingLongitude,
  billingLatitude,
  billingLongitude
) => {
  const latlngs = [];
  // Get latlng from first marker
  latlngs.push(marker.getLatLng());

  // eslint-disable-next-line new-cap
  const featureGroup = new L.featureGroup();
  marker.setLatLng(new L.LatLng(shippingLatitude, shippingLongitude), {
    draggable: "true",
  });

  featureGroup.addLayer(marker);
  if (marker1 !== "") {
    marker1.setLatLng(new L.LatLng(billingLatitude, billingLongitude), {
      draggable: "true",
    });
    featureGroup.addLayer(marker1);
  }
  featureGroup.addTo(map);
  map.fitBounds(featureGroup.getBounds());
};

export const initMap = (
  shippingLatitude,
  shippingLongitude,
  setPosition,
  billingLatitude,
  billingLongitude,
  setBillingPosition
) => {
  // let marker;
  let map;
  if (map !== undefined) {
    map.remove();
  }
  L.mapbox.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

  const orangeIcon = L.icon({
    iconUrl: "/build/images/marker-icon3.png",
    shadowUrl:
      "//api.tiles.mapbox.com/mapbox.js/v1.6.2/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    shadowAnchor: [12, 41],
  });

  const blueIcon = L.icon({
    iconUrl: "/build/images/marker-icon-blue.png",
    shadowUrl:
      "//api.tiles.mapbox.com/mapbox.js/v1.6.2/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    shadowAnchor: [12, 41],
  });

  const container = L.DomUtil.get("map");
  if (container != null) {
    container._leaflet_id = null;
  }

  map = L.mapbox
    .map("map")
    .setView([shippingLatitude, shippingLongitude], 8)
    .addLayer(L.mapbox.styleLayer(process.env.REACT_APP_MAPBOX_STYLE_ID));

  const marker = L.marker([shippingLatitude, shippingLongitude], {
    icon: orangeIcon,
    draggable: "true",
  });
  let marker1 = "";
  if (billingLatitude !== "") {
    marker1 = L.marker([billingLatitude, billingLongitude], {
      icon: blueIcon,
      draggable: "true",
    });
  }
  setTimeout(() => {
    loadMarker(
      marker,
      marker1,
      map,
      shippingLatitude,
      shippingLongitude,
      billingLatitude,
      billingLongitude
    );
  });

  marker.on("dragend", function (event) {
    let marker = event.target;
    let position = marker.getLatLng();
    marker.setLatLng(new L.LatLng(position.lat, position.lng), {
      icon: orangeIcon,
      draggable: "true",
    });
    map.panTo(new L.LatLng(position.lat, position.lng));
    setPosition(position);
  });

  if (marker1 !== "") {
    marker1.on("dragend", function (event) {
      marker1 = event.target;
      const position = marker1.getLatLng();
      marker1.setLatLng(new L.LatLng(position.lat, position.lng), {
        icon: blueIcon,
        draggable: "true",
      });
      map.panTo(new L.LatLng(position.lat, position.lng));
      setBillingPosition(position);
    });
  }
};
